import { TypedDocumentNode } from 'apollo-angular';
import {
	FileImportFragment,
	fileSessionInfoFragment,
	PageInfoFragment,
} from './file-import.fragments';

import gql from 'graphql-tag';

export interface IFileUploadUrl {
	fileUploadSignedUrl: string;
}

export const fileUploadSignedUrlQuery: TypedDocumentNode<IFileUploadUrl> = gql`
	query fileUploadSignedUrl($contentType: String = "application/zip") {
		fileUploadSignedUrl(contentType: $contentType)
	}
`;

export const FileImportQuery = gql`
	query ImportFilesQuery(
		$importId: UUID
		$hideImportedFiles: Boolean = false
		$assetTypeId: String
		$classifications: [String]
		$locations: [UUID]
		$type: [String]
		$search: String
		$first: Int
		$last: Int
		$after: String
		$before: String
		$hidePopulatedLocations: Boolean
		$hidePopulatedClassifications: String
		$hidePopulatedType: Boolean
		$hidePopulatedAssets: Boolean
		$hidePopulatedWorkOrders: Boolean
		$hidePopulatedIncidents: Boolean
		$hidePopulatedRequests: Boolean
		$showIsCompleted: Boolean
	) {
		importFiles(
			importId: $importId
			hideImportedFiles: $hideImportedFiles
			type: $type
			assetTypeId: $assetTypeId
			classifications: $classifications
			locations: $locations
			search: $search
			first: $first
			last: $last
			after: $after
			before: $before
			hidePopulatedLocations: $hidePopulatedLocations
			hidePopulatedClassifications: $hidePopulatedClassifications
			hidePopulatedType: $hidePopulatedType
			hidePopulatedAssets: $hidePopulatedAssets
			hidePopulatedWorkOrders: $hidePopulatedWorkOrders
			hidePopulatedIncidents: $hidePopulatedIncidents
			hidePopulatedRequests: $hidePopulatedRequests
			showIsCompleted: $showIsCompleted
		) {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...FileImportFragment
				}
			}
			totalCount
			fileImportCounters {
				missingLocationCount
				missingTypeCount
				totalCount
				missingClassifications {
					ns3451Count
					ns3456Count
					ns34578Count
				}
				missingCmmsLinks {
					incidentCount
					requestCount
					workOrderCount
					assetCount
				}
				importConfirmedCount
			}
		}
	}
	${FileImportFragment}
	${PageInfoFragment}
`;
export const fileSessionInfoQuery = gql`
	query fileEntitiesImports {
		fileEntitiesImports {
			pageInfo {
				...PageInfoFragment
			}
			edges {
				cursor
				node {
					...FileEntityImportFragment
				}
			}
		}
	}
	${PageInfoFragment}
	${fileSessionInfoFragment}
`;

export const sessionsQuery = gql`
	query FileImportSessions($pkIn: [UUID]) {
		fileEntitiesImports(pkIn: $pkIn) {
			edges {
				node {
					pk
					name
					created
					zipUuid
					status
					url
					counters {
						importConfirmedCount
						totalCount
					}
					createdBy {
						contentType
						firstName
						lastName
						name
						psId
						smallAvatarUrl
						smallLogoUrl
					}
				}
			}
		}
	}
`;

export const sessionQuery = gql`
	query SessionQuery($pkIn: [UUID]) {
		fileEntitiesImports(pkIn: $pkIn) {
			edges {
				node {
					pk
					name
					created
					zipUuid
					status
					url
					counters {
						importConfirmedCount
						totalCount
					}
				}
			}
		}
	}
`;

export const FilePksQuery = gql`
	query filePksQuery(
		$fileEntitiesImportPk: UUID!
		$hidePopulatedLocations: Boolean
		$hidePopulatedClassifications: String
		$hidePopulatedType: Boolean
		$hidePopulatedAssets: Boolean
		$showIsCompleted: Boolean
	) {
		filePks(
			fileEntitiesImportPk: $fileEntitiesImportPk
			hidePopulatedLocations: $hidePopulatedLocations
			hidePopulatedClassifications: $hidePopulatedClassifications
			hidePopulatedType: $hidePopulatedType
			hidePopulatedAssets: $hidePopulatedAssets
			showIsCompleted: $showIsCompleted
		)
	}
`;
